// import axios from "axios";
// import React, { useEffect, useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { motion } from "framer-motion";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import styles from "./BlogDetails.module.css";

// gsap.registerPlugin(ScrollTrigger);

// const BASE_URL = "https://ecom.cyberathon.com";

// function BlogDetails() {

//   const { id } = useParams();
//   const [blog, setBlog] = useState(null);
//   const sectionRef = useRef(null);

//   useEffect(() => {

//     const fetchBlog = async () => {

//       try {

//         const res = await axios.get(`${BASE_URL}/index.php/Api/list_blog`);

//         if (res.data.status) {

//           const found = res.data.data.find(
//             (b) => String(b.id) === String(id)
//           );

//           setBlog(found);
//         }

//       } catch (error) {
//         console.log(error);
//       }

//     };

//     fetchBlog();

//   }, [id]);



//   /* GSAP animation */

//   useEffect(() => {

//     if (sectionRef.current) {

//       gsap.fromTo(
//         sectionRef.current,
//         {
//           opacity: 0,
//           y: 80
//         },
//         {
//           opacity: 1,
//           y: 0,
//           duration: 1,
//           scrollTrigger: {
//             trigger: sectionRef.current,
//             start: "top 80%",
//           }
//         }
//       );

//     }

//   }, [blog]);


//   if (!blog) return <div className="text-center mt-5">Loading...</div>;


//   return (
//     <>
//       <Layout />

//       <section className="blog-details-section">

//         <div className="container">

//           <div className="row blog-details-row" ref={sectionRef}>

//             {/* IMAGE */}

//             <div className="col-lg-6">

//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 transition={{ duration: 0.3 }}
//                 className="blog-details-image"
//               >

//                 <img
//                   src={`${BASE_URL}/${blog.image}`}
//                   alt={blog.heading}
//                 />

//               </motion.div>

//             </div>


//             {/* CONTENT */}

//             <div className="col-lg-6 d-flex align-items-center">

//               <div className="blog-details-content">

//                 <span className="blog-date">
//                   {blog.day} {blog.month} {blog.year}
//                 </span>

//                 <h1>
//                   {blog.heading}
//                 </h1>

//                 <div
//                   className="blog-description"
//                   dangerouslySetInnerHTML={{ __html: blog.description }}
//                 />

//               </div>

//             </div>

//           </div>

//         </div>

//       </section>

//       <FooterNew />
//     </>
//   );
// }

// export default BlogDetails;



import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";

gsap.registerPlugin(ScrollTrigger);

const BASE_URL = "https://ecom.cyberathon.com";

function BlogDetails() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const contentRef = useRef(null);
const [seoData, setSeoData] = useState({});
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/index.php/Api/get_seo_by_page`, { page_name: 'blog_detail' });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/index.php/Api/list_blog`);
        if (res.data.status) {
          const found = res.data.data.find(
            (b) => String(b.id) === String(id)
          );
          setBlog(found);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchBlog();
  }, [id]);

  useEffect(() => {
    if (!blog) return;

    const tl = gsap.timeline();

    if (imageRef.current) {
      tl.fromTo(
        imageRef.current,
        { opacity: 0, x: -60, scale: 0.97 },
        { opacity: 1, x: 0, scale: 1, duration: 0.9, ease: "power3.out" }
      );
    }

    if (contentRef.current) {
      tl.fromTo(
        contentRef.current.children,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.12,
          ease: "power2.out",
        },
        "-=0.4"
      );
    }
  }, [blog]);

  if (!blog)
    return (
      <div style={loaderStyle}>
        <div style={spinnerStyle} />
      </div>
    );

  return (
    <>
    <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "ShopIndia is the best online shopping platform..."}
    keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
    canonical={seoData.canonical || "https://www.shopindia.com/"}
  />
      <Layout />

      <section style={sectionStyle}>
        {/* Decorative background blobs */}
        <div style={blobTopStyle} />
        <div style={blobBottomStyle} />

        <div style={containerStyle} ref={sectionRef}>

          {/* ── BREADCRUMB ── */}
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={breadcrumbStyle}
          >
            <span style={breadcrumbLinkStyle}>Blog</span>
            <span style={breadcrumbSepStyle}>›</span>
            <span style={breadcrumbCurrentStyle}>{blog.heading?.slice(0, 40)}…</span>
          </motion.div>

          {/* ── MAIN CARD ── */}
          <div style={cardStyle}>

            {/* LEFT — Image */}
            <div style={imageWrapStyle} ref={imageRef}>
              {/* Checkerboard bg for transparent images */}
              <div style={checkerBgStyle} />

              <img
                src={`${BASE_URL}/${blog.image}`}
                alt={blog.heading}
                style={imgStyle}
              />

              {/* Gradient overlay at bottom for polish */}
              <div style={imgOverlayStyle} />

              {/* Date badge pinned to image */}
              <div style={dateBadgeStyle}>
                <span style={dateDayStyle}>{blog.day}</span>
                <span style={dateMonthStyle}>{blog.month} {blog.year}</span>
              </div>
            </div>

            {/* RIGHT — Content */}
            <div style={contentWrapStyle} ref={contentRef}>

              <span style={categoryTagStyle}>Article</span>

              <h1 style={headingStyle}>{blog.heading}</h1>

              <div style={dividerStyle} />

              <div
                style={descStyle}
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />

              {/* <motion.button
                whileHover={{ scale: 1.04, backgroundColor: "#1a9497" }}
                whileTap={{ scale: 0.97 }}
                style={btnStyle}
              >
                Share Article ↗
              </motion.button> */}

            </div>

          </div>

        </div>
      </section>

      <FooterNew />

      <style>{responsiveCSS}</style>
    </>
  );
}

/* ─────────────────────────────────────────────
   INLINE STYLES
───────────────────────────────────────────── */

const sectionStyle = {
  minHeight: "100vh",
  padding: "100px 0 80px",
  background: "linear-gradient(135deg, #f0f4f8 0%, #e8f0fe 50%, #f5f0ff 100%)",
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Georgia', 'Times New Roman', serif",
};

const blobTopStyle = {
  position: "absolute",
  top: "-120px",
  right: "-100px",
  width: "500px",
  height: "500px",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(36,174,177,0.12) 0%, transparent 70%)",
  pointerEvents: "none",
};

const blobBottomStyle = {
  position: "absolute",
  bottom: "-80px",
  left: "-80px",
  width: "400px",
  height: "400px",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(99,102,241,0.10) 0%, transparent 70%)",
  pointerEvents: "none",
};

const containerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "0 24px",
  position: "relative",
  zIndex: 1,
};

const breadcrumbStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "32px",
  fontFamily: "'Helvetica Neue', Arial, sans-serif",
  fontSize: "13px",
};

const breadcrumbLinkStyle = {
  color: "#24aeb1",
  cursor: "pointer",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  fontWeight: 600,
};

const breadcrumbSepStyle = {
  color: "#aaa",
  fontSize: "16px",
};

const breadcrumbCurrentStyle = {
  color: "#888",
};

const cardStyle = {
  display: "flex",
  flexDirection: "row",
  background: "#ffffff",
  borderRadius: "24px",
  boxShadow: "0 30px 80px rgba(0,0,0,0.10), 0 4px 16px rgba(0,0,0,0.06)",
  overflow: "hidden",
  minHeight: "540px",
};

/* IMAGE SIDE */
const imageWrapStyle = {
  flex: "0 0 50%",
  position: "relative",
  overflow: "hidden",
  minHeight: "520px",
};

/* Checkerboard pattern for transparent images */
const checkerBgStyle = {
  position: "absolute",
  inset: 0,
  backgroundImage:
    "linear-gradient(45deg, #e0e0e0 25%, transparent 25%)," +
    "linear-gradient(-45deg, #e0e0e0 25%, transparent 25%)," +
    "linear-gradient(45deg, transparent 75%, #e0e0e0 75%)," +
    "linear-gradient(-45deg, transparent 75%, #e0e0e0 75%)",
  backgroundSize: "20px 20px",
  backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
  opacity: 0.5,
};

const imgStyle = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "contain",      /* Full image always visible */
  objectPosition: "center",
  padding: "24px",
  boxSizing: "border-box",
  transition: "transform 0.6s ease",
  zIndex: 1,
};

const imgOverlayStyle = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "120px",
  background: "linear-gradient(to top, rgba(255,255,255,0.4), transparent)",
  zIndex: 2,
  pointerEvents: "none",
};

const dateBadgeStyle = {
  position: "absolute",
  top: "20px",
  left: "20px",
  background: "#24aeb1",
  color: "#fff",
  borderRadius: "10px",
  padding: "10px 14px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 3,
  boxShadow: "0 4px 12px rgba(36,174,177,0.35)",
  fontFamily: "'Helvetica Neue', Arial, sans-serif",
};

const dateDayStyle = {
  fontSize: "26px",
  fontWeight: 700,
  lineHeight: 1,
};

const dateMonthStyle = {
  fontSize: "11px",
  fontWeight: 500,
  letterSpacing: "1px",
  textTransform: "uppercase",
  marginTop: "2px",
};

/* CONTENT SIDE */
const contentWrapStyle = {
  flex: 1,
  padding: "52px 48px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  background: "#fff",
  overflow: "hidden",
};

const categoryTagStyle = {
  display: "inline-block",
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "#24aeb1",
  background: "rgba(36,174,177,0.08)",
  border: "1px solid rgba(36,174,177,0.25)",
  borderRadius: "20px",
  padding: "5px 14px",
  marginBottom: "20px",
  fontFamily: "'Helvetica Neue', Arial, sans-serif",
  width: "fit-content",
};

const headingStyle = {
  fontSize: "clamp(24px, 2.8vw, 38px)",
  fontWeight: 700,
  color: "#111827",
  lineHeight: 1.2,
  marginBottom: "20px",
  letterSpacing: "-0.5px",
};

const dividerStyle = {
  width: "48px",
  height: "3px",
  borderRadius: "99px",
  background: "linear-gradient(90deg, #24aeb1, #6366f1)",
  marginBottom: "24px",
};

const descStyle = {
  fontSize: "16px",
  lineHeight: 1.85,
  color: "#4b5563",
  fontFamily: "'Georgia', serif",
  flex: 1,
  overflowY: "auto",
  maxHeight: "320px",
  paddingRight: "8px",
  scrollbarWidth: "thin",
  scrollbarColor: "#e5e7eb transparent",
};

const btnStyle = {
  marginTop: "32px",
  alignSelf: "flex-start",
  padding: "13px 28px",
  background: "#24aeb1",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontSize: "14px",
  fontWeight: 600,
  letterSpacing: "0.5px",
  cursor: "pointer",
  fontFamily: "'Helvetica Neue', Arial, sans-serif",
  boxShadow: "0 6px 20px rgba(36,174,177,0.30)",
  transition: "all 0.2s ease",
};

/* Loader */
const loaderStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "60vh",
};

const spinnerStyle = {
  width: "44px",
  height: "44px",
  border: "3px solid #e5e7eb",
  borderTop: "3px solid #24aeb1",
  borderRadius: "50%",
  animation: "spin 0.8s linear infinite",
};

/* ─────────────────────────────────────────────
   RESPONSIVE CSS (injected via <style>)
───────────────────────────────────────────── */
const responsiveCSS = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @media (max-width: 900px) {
    /* Stack vertically on tablet/mobile */
    div[style*="flex-direction: row"] {
      flex-direction: column !important;
    }
  }

  @media (max-width: 900px) {
    /* Image takes full width */
  }

  /* Scrollbar styling for desc */
  .blog-desc-scroll::-webkit-scrollbar {
    width: 4px;
  }
  .blog-desc-scroll::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 99px;
  }

  /* Hover zoom on image */
  .blog-img-hover:hover img {
    transform: scale(1.04);
  }
`;

export default BlogDetails;